import { createReducer } from '../../util';
import * as actions from '../actions/npiRoles';
import { StatusState } from './common';

const initialStatusState : StatusState = {
    error: false,
    errorMessage: '',
    pending: false,
};

const initialState = {
    data: [],
    npiRolesFromContract: [],
    npiRolesFromTargetClient: [],
    list: {
        ...initialStatusState,
    },
    create: {
        ...initialStatusState,
    },
    update: {
        ...initialStatusState,
    },
    get: {
        ...initialStatusState,
    },
    delete: {
        ...initialStatusState,
    },
    getNpiRolesFromContract: {
        ...initialStatusState
    },
    getNpiRolesFromTargetClient: {
        ...initialStatusState
    },
};

export default createReducer(initialState, {
    [actions.NPI_ROLES_LANDING_PENDING]: (state) => ({
        ...state,
        list: {
            pending: true,
        },
        data: []
    }),
    [actions.NPI_ROLES_LANDING_FULFILLED]: (state, npiRoles) => ({
        ...state,
        list: {
            ...initialStatusState,
        },
        data: npiRoles,
    }),
    [actions.NPI_ROLES_LANDING_REJECTED]: (state, errorMessage) => ({
        ...state,
        list: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.NPI_ROLES_CREATE_PENDING]: (state) => ({
        ...state,
        create: {
            pending: true,
        },
    }),
    [actions.NPI_ROLES_CREATE_FULFILLED]: (state) => ({
        ...state,
        create: {
            ...initialStatusState,
        },
    }),
    [actions.NPI_ROLES_CREATE_REJECTED]: (state, errorMessage) => ({
        ...state,
        create: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.NPI_ROLES_UPDATE_PENDING]: (state) => ({
        ...state,
        update: {
            pending: true,
        },
    }),
    [actions.NPI_ROLES_UPDATE_FULFILLED]: (state) => ({
        ...state,
        update: {
            ...initialStatusState,
        },
    }),
    [actions.NPI_ROLES_UPDATE_REJECTED]: (state, errorMessage) => ({
        ...state,
        update: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.NPI_ROLES_DELETE_PENDING]: (state) => ({
        ...state,
        delete: {
            pending: true,
        },
    }),
    [actions.NPI_ROLES_DELETE_FULFILLED]: (state) => ({
        ...state,
        delete: {
            ...initialStatusState,
        },
    }),
    [actions.NPI_ROLES_DELETE_REJECTED]: (state, errorMessage) => ({
        ...state,
        delete: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.NPI_ROLES_CREATE_UPDATE_RESET]: (state) => ({
        ...state,
        update: {
            ...initialStatusState,
        },
        create: {
            ...initialStatusState,
        },
    }),

    [actions.NPI_ROLES_GET_BY_CONTRACT_PENDING]: (state) => ({
        ...state,
        getNpiRolesFromContract: {
            pending: true,
        }
    }),
    [actions.NPI_ROLES_GET_BY_CONTRACT_FULFILLED]: (state, npiRolesFromContract) => ({
        ...state,
        getNpiRolesFromContract: {
            ...initialStatusState,
        },
        npiRolesFromContract,
    }),
    [actions.NPI_ROLES_GET_BY_CONTRACT_REJECTED]: (state, errorMessage) => ({
        ...state,
        getNpiRolesFromContract: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

    [actions.NPI_ROLES_GET_BY_TARGET_CLIENT_PENDING]: (state) => ({
        ...state,
        getNpiRolesFromTargetClient: {
            pending: true,
        }
    }),
    [actions.NPI_ROLES_GET_BY_TARGET_CLIENT_FULFILLED]: (state, npiRolesFromTargetClient) => ({
        ...state,
        getNpiRolesFromTargetClient: {
            ...initialStatusState,
        },
        npiRolesFromTargetClient,
    }),
    [actions.NPI_ROLES_GET_BY_TARGET_CLIENT_REJECTED]: (state, errorMessage) => ({
        ...state,
        getNpiRolesFromTargetClient: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),
});
